import { FC } from 'react';
import { useSelector } from 'react-redux';
// @ts-ignore
import HubspotForm from 'react-hubspot-form';

import { RootState } from 'types';

import logo from 'assets/images/logo.svg';
import styles from './EnterprisePlan.module.css';
import texts from './texts';
import { t } from 'utils';

export const EnterprisePlan: FC = () => {
  const { userInfo } = useSelector((state: RootState) => state.user);

  return (
    <>
      <div className={styles.wrap}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <a href="/dashboard" style={{ margin: '36px 0 60px 0', display: 'inline-block' }}>
            <img src={logo} alt="logo" />
          </a>
        </div>
        <div style={{ display: 'flex' }}>
          <div>
            <h1 style={{ textTransform: 'capitalize' }}>
              {t(texts.enterprisePlan.hi)}
              {`, ${userInfo.fullName}`}
            </h1>
            <div className={styles.order}>
              <p style={{ fontStyle: 'italic' }}>{t(texts.enterprisePlan.freeTrial)}</p>
              <p style={{ fontStyle: 'italic' }}>{t(texts.enterprisePlan.desc)}</p>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.contacts}>
        <div className={styles.wrap}>
          <div className={styles.contactsWrap}>
            <h2 style={{ fontSize: '40px', color: '#fff' }}>{t(texts.enterprisePlan.contactUs)}</h2>
            <div>
              <p style={{ color: '#fff' }}>{t(texts.enterprisePlan.email)}</p>
              <a href="mailto:info@eyetelligence.com.au" style={{ color: '#fff' }}>
                info@eyetelligence.com.au
              </a>
            </div>
            <div>
              <p style={{ color: '#fff' }}>{t(texts.enterprisePlan.mail)}</p>
              <p style={{ lineHeight: 0.5, color: '#fff' }}>{t(texts.enterprisePlan.street)},</p>
              <p style={{ color: '#fff' }}>{t(texts.enterprisePlan.city)}</p>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.wrap}>
        <div className={styles.form}>
          <div className={styles.left}>
            <h2>{t(texts.enterprisePlan.chat)}!</h2>
            <p>{t(texts.enterprisePlan.description)}</p>
          </div>
          <div className={styles.right}>
            <HubspotForm
              portalId="9363620"
              formId="363ff205-9d48-4ebd-aa1f-efea150b1496"
              onSubmit={() => console.log('Submit!')}
              onReady={() => console.log('Form ready!')}
              loading={<div>{t(texts.enterprisePlan.loading)}...</div>}
            />
          </div>
        </div>
      </div>
    </>
  );
};
